<template>
  <div class="rolemanagetable">
    <el-table :data="tableData"
              style="width: 100%;padding:10px 10px 0 10px;"
              border>
      <el-table-column prop="createAtMY"
                       label="推送时间"
                        width="140"></el-table-column>
      <el-table-column prop="title"
                       label="标题"
                       width="200"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button @click="openDesc(scope)"
                     style="color: #5b9bd1;"
                     type="text"
                     class="btn"
                     size="small">{{scope.row.title}}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="附加信息" width="100">
        <template slot-scope="scope">
          <el-button @click="openClick(scope)"
                     style="color: #5b9bd1;"
                     type="text"
                     class="btn"
                     size="small">点击查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="pictureCount"
                       label="图片数量" width="70"></el-table-column>
      <el-table-column v-if="isToMe !== false" 
                       prop="pushName"
                       label="推送用户"></el-table-column>
      <el-table-column v-if="isToMe !== false" 
                       prop="channel"
                       label="推送渠道">
      </el-table-column>
      <el-table-column v-if="isToMe == false" 
                       prop="toPushName"
                       label="推送来源">
      </el-table-column>
      <el-table-column prop="statusTitle"
                       v-if="isToMe !== false"
                       width="200"
                       label="推送状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'success'">
            <el-tag type="success">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'error' ">
            <el-tag type="danger">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'none'">
            <el-tag type="info">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'warn'">
            <el-tag type="warning">{{scope.row.statusTitle}}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="250">
        <template slot-scope="scope">
          <!-- <div>无</div> -->
          <el-button @click="seePic(scope)"
                     type="text"
                     style="color:#3086F0;font-weight:bold;font-size:13px;"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-picture-outline"></i>查看图片</el-button>
          <!-- <div v-if="scope.row.status !== '失败' && scope.row.status !== '推送中……'">
            <el-button @click="closeClick(scope)" type="text" class="btn" size="small">撤回</el-button>
          </div>

          <div v-if="scope.row.status === '失败' ">
            <el-button @click="openClick(scope)" type="text" class="btn" size="small">重新推送</el-button>
            <span style="margin:0 8px;"> | </span>
            <el-button @click="changeClick(scope)" type="text" class="btn" size="small">修改</el-button>
          </div>

          <div v-if="scope.row.status === '推送中……'">
            <div>推送中无法操作</div>
          </div>-->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="msgDialog"
               width="30%"
               :before-close="handleClosedetail">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>附加信息</div>
      </div>
      <div>
        <el-input type="textarea"
                  :autosize="{ minRows: 6, maxRows: 8}"
                  placeholder="暂无"
                  v-model="pushConfig"
                  :disabled="true"></el-input>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="descDialog"
               width="30%"
               :before-close="handleClosedesc">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>查看备注</div>
      </div>
      <div>
        <span>{{desc || '暂无'}}</span>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { getPicturePackage } from "@/api/picturePackage";
export default {
  name: "rolemanagetable",
  props: {
    tableData: Array,
    isToMe: {
      required: true
    }
  },
  data () {
    return {
      isPush: 1,
      msgDialog: false,
      pushConfig: '',
      descDialog:false,
      desc:""
      // tableData:[
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     channel:'路特全媒体',
      //     state:'失败'
      //   },
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     channel:'路特全媒体',
      //     state:'推送中……'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     channel:'路特全媒体',
      //     state:'成功'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     channel:'路特全媒体',
      //     state:'2000次'
      //   },
      // ]
    };
  },
  methods: {
    openClick (scope) {
      this.msgDialog = true;
      this.getPicturePackageAsync(scope.row.id)
    },

    handleClosedesc(){
      this.desc = ''
      this.descDialog = false
    },
    openDesc (scope) {
      this.desc = JSON.parse(scope.row.pushConfig).note
      this.descDialog = true;
    },

    closeClick (scope) {
      // console.log(scope)
    },
    changeClick (scope) {
      this.$emit("changeClick", scope);
    },
    removeClick (scope) {
      this.$emit("removeClick", scope);
    },
    seePic (scope) {
      this.$emit('seePic', scope)
    },
    handleClosedetail () {
      this.msgDialog = false;
    },

    //获取推送详情
    async getPicturePackageAsync (val) {
      let { status, data, message, errors } = await getPicturePackage(val);
      if (status) {
        this.pushConfig = data.pushConfig
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    }
  },
  created () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}
</style>
